// @ts-nocheck
import { FormModel } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import React, { createContext, FC } from "react";

export interface Props {
    form: FormModel | null;
}

const defaultForm = {
    id: "",
    inputs: [],
    hasAlreadyError: false,
};

export const FormContext = createContext<FormModel>(defaultForm);

const StoreFormContextProvider: FC<Props> = ({ form, children }) => {
    return <FormContext.Provider value={form || defaultForm}>{children}</FormContext.Provider>;
};

export default StoreFormContextProvider;
